/**
 * MiglioraTuttePointer — iter v33 r29
 * ────────────────────────────────────────────────────────────────────────
 * User: «Onboarding Prima Foto: alla prima apertura del tab Foto mostra
 * un fumetto grande "Premi Migliora tutte per iniziare" cosi l'agente sa
 * dove cliccare senza pensarci».
 *
 * Renderizza un fumetto sage-green sopra al bottone "Migliora tutte" della
 * hero bar. Auto-dismiss dopo 8s, o al primo click ovunque, o quando
 * l'agente preme la X. Persistente via localStorage: si vede una sola
 * volta per browser.
 *
 * Non renderizza se:
 *   - l'agente ha gia' migliorato almeno 1 foto (ha capito il flow)
 *   - non ci sono foto ancora (niente da migliorare)
 *   - il flag "seen" e' presente in localStorage
 */
import React, { useEffect, useState } from "react";
import { X } from "@phosphor-icons/react";

const STORAGE_KEY = "pronto:migliora-tutte-pointer-v1";

export default function MiglioraTuttePointer({ show, testid = "migliora-tutte-pointer" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!show) return undefined;
    let seen = false;
    try {
      seen = !!localStorage.getItem(STORAGE_KEY);
    } catch { /* localStorage non disponibile */ }
    if (seen) return undefined;
    // Piccolo delay cosi' l'agente prima vede la galleria appena montata,
    // e poi appare il fumetto (senza sovrapporsi allo skeleton).
    const t1 = setTimeout(() => setVisible(true), 800);
    // Auto-dismiss dopo 10 secondi.
    const t2 = setTimeout(() => {
      setVisible(false);
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch { /* noop */ }
    }, 10800);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [show]);

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch { /* noop */ }
  };

  if (!show || !visible) return null;

  return (
    <div
      className="mt-3 relative animate-in fade-in slide-in-from-top-2 duration-500"
      data-testid={testid}
      role="dialog"
      aria-label="Suggerimento onboarding"
    >
      <div className="bg-[#1C1C1A] text-white rounded-2xl px-4 py-3.5 shadow-[0_14px_40px_-8px_rgba(28,28,26,0.35)] flex items-center gap-3">
        {/* Freccia che punta al bottone in basso a destra */}
        <div className="absolute -bottom-2 right-8 w-4 h-4 bg-[#1C1C1A] rotate-45"></div>
        <span
          className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#7C8B6E] text-white text-[13px] font-bold shrink-0"
          aria-hidden="true"
        >
          1
        </span>
        <div className="flex-1 min-w-0">
          <div className="text-[13.5px] font-semibold leading-tight">
            Premi &laquo;Migliora tutte&raquo; per iniziare
          </div>
          <div className="text-[11.5px] text-white/70 mt-0.5 leading-snug">
            Un tap sistema luce, colori e prospettiva su tutte le foto. Decidi
            tu quando farlo &mdash; puoi anche riordinare prima.
          </div>
        </div>
        <button
          onClick={dismiss}
          className="shrink-0 -mr-1 p-1.5 rounded-full hover:bg-white/10 transition-colors"
          aria-label="Chiudi suggerimento"
          data-testid={`${testid}-close`}
        >
          <X size={13} weight="bold" className="text-white/70" />
        </button>
      </div>
    </div>
  );
}
